import React, { useEffect, useReducer, createContext, useContext, useState } from 'react';
import { format } from 'date-fns';
import {saveAs} from 'file-saver';
import { LanguageContext } from "../../containers/Language/LanguageProvider";
import { RevenueCalendarContext } from '../context/RevenueCalendarProvider';
import { isNullOrUndefined } from 'util';
import { fetchDailyRevenueDetails, submitDailyRevenueDetails, importFromExcel, exportToExcel, fetchRemarksOptions, 
        submitSelectedDailyRevenueDetails, submitUnblockContractRequest} from '../actions/actionSelectors';
import { FETCH_DAILY_REVENUE_DETAILS, SET_REVENUE_EMPTY, SET_SELECTEDREVENUE_DATA_REQUEST, SET_SELECTEDREVENUE_DATA, 
        SUBMITTED_REVENUE_REQUEST, SUBMITTED_REVENUE, UPLOAD_FILE_REQUEST, UPLOAD_EXCEL_REQUEST, UPLOAD_EXCEL_SUCCESS,
        FETCH_REMARK_OPTIONS, CANCEL_CHANGE_REQUEST, SUBMIT_CHANGE_REQUEST, CHANGE_REQUEST_NOT_ALLOWED, 
        SUBMIT_SELECTED_SUCCESS, TOGGLE_UPLOAD_FILE_MODEL, TOGGLE_UNBLOCK_REQUEST_MODEL, 
        SET_SELECT_UNBLOCK_REQUEST_REVENUE, UNBLOCK_REQUEST_NOT_ALLOWED, SUBMIT_UNBLOCK_REQUEST,FETCH_WEEKLY_REVENUE_DETAILS, UPLOAD_WEEKLY_EXCEL_SUCCESS
    } from '../actions/actionTypes';
import { revenueReducer } from '../actions/revenue-reducer';
import config from '../../common/const/config'
import { RequestStatus } from '../../common/const/RequestStatus';
import { checkChangeRequestDataChanged } from '../../common/const/changeRequestHelper';
import {isValueNullOrUndefinedOrEmpty, findUnique} from '../../common/utility/utility';
import TranslationErrorPopup from '../../components/UI/Modal/translationErrorPopup';

const initialState = {
    revenue: [],
    remarksOptions: null,
    setSelectedRevenue: null,
    submittedRevenue: null,
    submittedRevenueId: null,
    selectedContractCodeIndex: null,
    selectedContractCode: null,
    modelHeaderTitle: "",
    showUploadFileModel: false,
    acceptFileType: undefined,
    selectedRevenue: null,
    showUnblockRequestModel: false
}

export const RevenueContext = createContext();

export function RevenueProvider(props) {
    const [state, dispatch] = useReducer(revenueReducer, initialState);
    const languageContext = useContext(LanguageContext);

    const [showPopup,setPopup] = useState(false)

    const { revenueDate, minDate, maxDate, newSelectedDate, isDateChangeFlag, setRevenueDate, setErrorOrWarningHandler, 
        ShowOrHideLoader, resetSubmittedAndErrorFlags, setChangeRequestNumber, fetchStatuswiseRevenueDatesHandler,
        setRevenueDataLoadingFlag, setUnblockFromDateAndContractCode, weeklyStartDate, weeklyEndDate,
        newWeeklyStartDate,  newWeeklyEndDate, setWeeklyStartDate,
        setWeeklyEndDate } = useContext(RevenueCalendarContext);

    const { revenue, modelHeaderTitle, showUploadFileModel, acceptFileType, selectedRevenue, selectedContractCodeIndex,
        remarksOptions, showUnblockRequestModel} = state;

    useEffect(() => {
        if(revenueDate || weeklyStartDate) {
            if(!remarksOptions) {
                async function fetchRemarkOptionsAsync() {
                    await fetchRemarkOptionsHandler()
                }    
                fetchRemarkOptionsAsync();
            }

            async function fetchDailyRevenueDetailsAsync() {
                await fetchDailyRevenueDetailsHandler(revenueDate, weeklyStartDate, weeklyEndDate);
            }
            fetchDailyRevenueDetailsAsync();
        }
    }, [revenueDate,weeklyStartDate]);    

    useEffect(() => {
        if(isDateChangeFlag || props.isLogout) {
            checkIfModification(newSelectedDate, newWeeklyStartDate, newWeeklyEndDate);
        }
    }, [isDateChangeFlag, props.isLogout]);

    const resetUploadFileFlags = (isShowModel, type, title) => {
        resetSubmittedAndErrorFlags();
        dispatch({ type: TOGGLE_UPLOAD_FILE_MODEL,
            payload: {
                showUploadFileModel : isShowModel,
                acceptFileType: type,
                modelHeaderTitle: title
            } 
        });  
    }    

    const fetchDailyRevenueDetailsHandler = async (dailyRevenueDate, startDate, endDate) => {
        ShowOrHideLoader(true);
        setRevenueDataLoadingFlag(true);
        await fetchDailyRevenueDetails(props.BusinessPartnerCode, dailyRevenueDate, startDate, endDate, props.isWeekly)
            .then((data) => {
                !props.isWeekly ?
                dispatch({
                    type: FETCH_DAILY_REVENUE_DETAILS,
                    payload: {
                        revenue: data && typeof(data) !== 'string' && data.length ? data : []
                    }
                }) :
                dispatch({
                    type: FETCH_WEEKLY_REVENUE_DETAILS,
                    payload: {
                        revenue: data && typeof(data) !== 'string' && data.length ? data : []
                    }
                });
                ShowOrHideLoader(false);
                setRevenueDataLoadingFlag(false);
            })
            .catch((error) => {
                dispatch({ type: SET_REVENUE_EMPTY });
                setRevenueDataLoadingFlag(false);
                setErrorOrWarningHandler(true, "wentwrong", false, true, "dailyrevenue", false, false);
            })
    }

    const checkIfModification = (selectedDate, selectedStartDate, selectedEndDate) =>{
        let error = "";       
        let isModificationError = false;

         revenue && revenue.length > 0 && revenue.map((d) => {
            if (!d.isSubmitted)  {                
                if(!checkForNullOrEmpty(d.revenueAmount.tax_0) || (!checkForNullOrEmpty(d.revenueAmount.tax_6))
                    || (!checkForNullOrEmpty(d.revenueAmount.tax_12)) || (!checkForNullOrEmpty(d.revenueAmount.tax_21))
                    || (!checkForNullOrEmpty(d.soldTicket))) {
                        error = "modification_notsaved";            
                }   
            } else if(d.isChangeRequestAllowed && d.changeRequest && (checkChangeRequestDataChanged(d) || 
                    (!isValueNullOrUndefinedOrEmpty(d.changeRequest.businessPartnerRemarks)))) {
                error = "modification_notsaved";
            }
         });

        if (error.trim() !== "") {
            isModificationError = true;
        }

        if (isModificationError) {            
            setErrorOrWarningHandler(isModificationError, error, false, true, "unsaved_changes", false, false)
        } 
        else 
        {
            if(props.isLogout) {
                props.clearSessionData();
            } else {
                if(props.isWeekly) {
                    setWeeklyStartDate(selectedStartDate);
                    setWeeklyEndDate(selectedEndDate);
                } else {
                    setRevenueDate(selectedDate);  
                }
            }
        }
    }

    const setRevenueDataHandler = (index, selectedContractCode, selectedRevenueData, isUnblockRequest) => {
        dispatch({ type: SET_SELECTEDREVENUE_DATA_REQUEST });

        dispatch({
            type: isUnblockRequest ? SET_SELECT_UNBLOCK_REQUEST_REVENUE : SET_SELECTEDREVENUE_DATA,
            payload: {
                selectedContractCodeIndex: index,
                selectedContractCode: selectedContractCode,
                selectedRevenue: selectedRevenueData
            }
        });
        
    }

    const submitRevenueHandler = async (index, selectedContractCode, submittedRevenue, submittedRevenueDate, isChangeRequest) => {
        ShowOrHideLoader(true);
        setChangeRequestNumber(null);
        dispatch({
            type: SUBMITTED_REVENUE_REQUEST,
            payload: {
                selectedContractCodeIndex: index,
                selectedContractCode: selectedContractCode,
                submittedRevenue: submittedRevenue,
            }
        });

        await submitDailyRevenueDetails(submittedRevenue, submittedRevenueDate, props.UserId, isChangeRequest, props.isWeekly)
            .then((data) => {
                if (!isChangeRequest) {
                    const isSuccessed = !isNullOrUndefined(data) && data.revenueId > 0;
                    if(isSuccessed) {
                        dispatch({
                            type: SUBMITTED_REVENUE,
                            payload: {
                                selectedContractCodeIndex: index,
                                submittedRevenueId: data.revenueId,
                                submittedRevenue: submittedRevenue,
                                changeRequestData: data
                            }
                        });
                        setErrorOrWarningHandler(false, "", false, true, "dailyrevenue", false , (!isNullOrUndefined(data) && data.revenueId ? true : false), 0, data.isMonthlyRevenueSubmitted); 
                        !isNullOrUndefined(data) && data.revenueId && minDate && maxDate && fetchStatuswiseRevenueDatesHandler(minDate, maxDate, true);
                    } else {
                        setErrorOrWarningHandler(true, "wentwrong", false, true, "dailyrevenue", false, false);
                    }
                } else { 
                    if(data && data.changeRequestNumber && data.changeRequestStatus && !data.validationErrorMessage) {
                        dispatch({
                            type: SUBMIT_CHANGE_REQUEST,
                            payload: {
                                selectedContractCodeIndex: index,
                                submittedRevenue: submittedRevenue,
                                changeRequestData: data 
                            }
                        });
                        setErrorOrWarningHandler(false, "", false, true, "cr_submission", false , data.changeRequestNumber !== "") 
                        setChangeRequestNumber(data.changeRequestNumber);
                    } else {
                        if(data && ((data.changeRequestNumber && data.changeRequestNumber.trim() === "")
                            || (data.validationErrorMessage && data.validationErrorMessage.trim() !== ""))) {
                            dispatch({
                                type: CHANGE_REQUEST_NOT_ALLOWED,
                                payload: {
                                    selectedContractCodeIndex: index,
                                    submittedRevenue: submittedRevenue
                                }
                            });
                            setErrorOrWarningHandler(true, data.validationErrorMessage, false, true, "cr_submission", false, false);
                        } else {
                            setErrorOrWarningHandler(true, "wentwrong", false, true, "cr_submission", false, false);
                        }
                    }
                }
            })
            .catch((error) => {
                setErrorOrWarningHandler(true, "wentwrong", false, true, isChangeRequest ? "cr_submission" : "dailyrevenue", false, false);
            })
    }

    const handlerOnImportFromExcelClick = () => {        
        let titleTag = document.getElementById('titleTag')
    
        if(titleTag.hasAttribute('_msthash')){
            setPopup(true)
        }
    else{
        ShowOrHideLoader(false);
        dispatch({ type: UPLOAD_FILE_REQUEST, 
            payload: {
                acceptFileType: config.alloweImportFileExtentions,
                modelHeaderTitle: "importexcel",
                selectedContractCodeIndex: null,
                selectedRevenue: null
            } 
        });
    }
    }

    const handlerOnUploadExcelClick = async (selectedFile) => {
        const selectedLangId = parseInt(languageContext.language.id);
        ShowOrHideLoader(true);
        dispatch({ type: UPLOAD_EXCEL_REQUEST });
        
        await importFromExcel(selectedFile, props.BusinessPartnerCode, revenueDate, weeklyStartDate, 
            weeklyEndDate, selectedLangId, props.isWeekly)
            .then((data) => {
                if (data && data.length > 0) {
                    const isAnyRevenueDataInvalid = data.some(d=>!d.isRevenueValid);
                    const errMsg = isAnyRevenueDataInvalid ? "missingorincorrectvalue" : "";
                    dispatch({
                            type: !props.isWeekly ? UPLOAD_EXCEL_SUCCESS : UPLOAD_WEEKLY_EXCEL_SUCCESS,
                            payload: {
                                revenue: data
                            }
                    });

                    setErrorOrWarningHandler(isAnyRevenueDataInvalid, errMsg, false, true, "dailyrevenue", !(isAnyRevenueDataInvalid), false);
                } else {
                    setErrorOrWarningHandler(true, "wentwrong", false, true, "dailyrevenue", false, false);
                }
            })
            .catch((error) => {
                setErrorOrWarningHandler(true, error.response && error.response.data ? error.response.data : "wentwrong", 
                                        false, true, "dailyrevenue", false, false);
            })
    }

    const handlerOnExportToExcelClick = async () => {
        let titleTag = document.getElementById('titleTag')
        const selectedLangId = parseInt(languageContext.language.id);
    
        if(titleTag.hasAttribute('_msthash')){
            setPopup(true)
        }
        else{
        if(languageContext && languageContext.language) {
        ShowOrHideLoader(true);

        const bpCode = props.BusinessPartnerCode

        await exportToExcel(bpCode, revenueDate, weeklyStartDate, weeklyEndDate, selectedLangId, props.isWeekly)    
                .then((data)=>{
                        ShowOrHideLoader(false);
                        const tempDate = format(new Date(), "ddMMyyyy:HHmmss");
                        const fileName = bpCode + "_" + tempDate + ".xlsx";
                        saveAs(new Blob([data]), fileName);                        
                })
                .catch((error)=>{
                    setErrorOrWarningHandler(true, "wentwrong", false, true, "dailyrevenue", false, false);
                })
            }
    } 
} 

    const checkForNullOrEmpty = (fieldValue) => {
        return fieldValue === null || fieldValue === "" || fieldValue === -1 ;
    }

    const fetchRemarkOptionsHandler = async () => {
        ShowOrHideLoader(true);
        await fetchRemarksOptions()
            .then((data) => {
                dispatch({
                    type: FETCH_REMARK_OPTIONS,
                    payload: {
                        remarksOptions: data && typeof(data) !== 'string' ? data : null
                    }
                });
                ShowOrHideLoader(false);
            })
            .catch((error) => {
                setErrorOrWarningHandler(true, "wentwrong", false, true, "dailyrevenue", false, false);
            })
    }

    const cancelChangeRequestHandler = async (index, selectedContractCode, selectedRevenueData) => {
        dispatch({
            type: CANCEL_CHANGE_REQUEST,
            payload: {
                selectedContractCodeIndex: index,
                selectedContractCode: selectedContractCode,
                changeRequestData: selectedRevenueData
            }
        });
    }

    const submitSelectedRevenueHandler = async (selectedUnsubmittedRevenues, revDate) => {
        if(selectedUnsubmittedRevenues && selectedUnsubmittedRevenues.length > 0) {
            ShowOrHideLoader(true);
            await submitSelectedDailyRevenueDetails(selectedUnsubmittedRevenues, revDate, props.UserId, props.isWeekly)
                .then((data) => {
                    const isSuccessed = !isNullOrUndefined(data) && data.length > 0 && data.every(d=>d.revenueId > 0);
                    if (isSuccessed) {
                        dispatch({
                            type: SUBMIT_SELECTED_SUCCESS,
                            payload: {
                                revDate: revDate,
                                isWeekly: props.isWeekly,
                                changeRequestData: !isNullOrUndefined(data) && data
                            }
                        });
                        let isMonthRevenueSubmitCheck = !data.every(d => d.isMonthlyRevenueSubmitted === false);
                        
                        let contractCodeList= data && findUnique(data.filter(d => d.isMonthlyRevenueSubmitted === true), e=>e.contractCode).map(d => d.contractCode).join(",");
                        
						contractCodeList = contractCodeList.split(',').map(item => <li>{item}</li>);
						
                        setErrorOrWarningHandler(false, "", false, true, "dailyrevenue", false, isSuccessed, RequestStatus.Success.id, isMonthRevenueSubmitCheck, contractCodeList);

                        minDate && maxDate && fetchStatuswiseRevenueDatesHandler(minDate, maxDate, true);
                    } else {
                        setErrorOrWarningHandler(true, "failed_message", false, true, "dailyrevenue", false, false, RequestStatus.Failed.id);
                    }
                })
                .catch((error) => {
                    setErrorOrWarningHandler(true, "failed_message", false, true, "dailyrevenue", false, false, RequestStatus.Failed.id);
                })
        } else {
            setErrorOrWarningHandler(true, "nodata", false, true, "dailyrevenue", false, false);
        }      
    }

    const resetUnblockRequestFlag = (showUnblockModel, isResetSelectedRevenue) => {
        if(isResetSelectedRevenue) {
            dispatch({ type: SET_SELECTEDREVENUE_DATA_REQUEST });
        }
        
        if(showUnblockModel) {
            setChangeRequestNumber(null);
            setUnblockFromDateAndContractCode(null, null);
        }

        dispatch({ type: TOGGLE_UNBLOCK_REQUEST_MODEL, 
            payload: {                        
                showUnblockRequestModel : showUnblockModel             
            } 
        });
    }

    const handlerOnUnblockRequestIconClick = (row, rowIndex) => {  
        if(row && !row.isSubmitted && !row.isMonthlySubmitted)
        {  
            setRevenueDataHandler(rowIndex, row.contractCode, row, true)         
            resetUnblockRequestFlag(true, false);
        }       
    }

    const onSubmitUnblockRequestHandler = async (ev, submittedData) => {
        ShowOrHideLoader(true);
        setChangeRequestNumber(null);
        const unblockFromDt = submittedData.unblockChangeRequest ? submittedData.unblockChangeRequest.unblockFromDate : null;
        setUnblockFromDateAndContractCode(unblockFromDt, submittedData.contractCode);
        let requestData = {
            "businessPartnerCode": props.BusinessPartnerCode,
            "contractCode": submittedData.contractCode,
            "businessPartnerRemarks": submittedData.unblockChangeRequest.businessPartnerRemarks,
            "createdBy": props.UserId
        }

        await submitUnblockContractRequest(requestData)
            .then((data) => {
                resetUnblockRequestFlag(false, false);
                if(data && data.changeRequestNumber && data.changeRequestStatus && !data.validationErrorMessage) {
                    dispatch({
                        type: SUBMIT_UNBLOCK_REQUEST,
                        payload: {
                            selectedContractCodeIndex: submittedData.index,
                            unblockRequestData: data,
                            selectedContractCode : submittedData.contractCode
                        }
                    });
                    setErrorOrWarningHandler(false, "", false, true, "cr_submission", false , data.changeRequestNumber !== "", RequestStatus.SuccessCr.id) 
                    setChangeRequestNumber(data.changeRequestNumber);
                } else {
                    if(data && ((data.changeRequestNumber && data.changeRequestNumber.trim() === "")
                            || (data.validationErrorMessage && data.validationErrorMessage.trim() !== ""))) {
                        dispatch({
                            type: UNBLOCK_REQUEST_NOT_ALLOWED,
                            payload: {
                                selectedContractCodeIndex: submittedData.index,
                                selectedRevenue: submittedData
                            }
                        });
                        setErrorOrWarningHandler(true, data.validationErrorMessage, false, true, "cr_submission", false, false, RequestStatus.FailedCr.id);
                    } else {
                        setErrorOrWarningHandler(true, "wentwrong", false, true, "cr_submission", false, false, RequestStatus.FailedCr.id);
                    }
                }
            })
            .catch((error) => {
                resetUnblockRequestFlag(false, false);
                setErrorOrWarningHandler(true, "wentwrong", false, true, "cr_submission", false, false, RequestStatus.FailedCr.id);
            })
    }

    const provider = {
        revenue, 
        modelHeaderTitle, 
        showUploadFileModel, 
        acceptFileType, 
        selectedRevenue, 
        selectedContractCodeIndex,
        remarksOptions,
        showUnblockRequestModel,
        handlerOnUploadExcelClick: handlerOnUploadExcelClick,
        handlerOnImportFromExcelClick: handlerOnImportFromExcelClick,
        handlerOnExportToExcelClick: handlerOnExportToExcelClick,
        setRevenueDataHandler: setRevenueDataHandler,
        submitRevenueHandler: submitRevenueHandler,
        checkIfModification: checkIfModification,
        cancelChangeRequestHandler,
        submitSelectedRevenueHandler,
        resetUploadFileFlags,
        handlerOnUnblockRequestIconClick,
        resetUnblockRequestFlag,
        onSubmitUnblockRequestHandler
    }

    return (
        <RevenueContext.Provider value={provider}>
            {props.children}
            {showPopup && <TranslationErrorPopup showPopup={showPopup} setShowPopup={setPopup} />}
        </RevenueContext.Provider>
    );
}
